export function stringifyOrderLine(orderLine) {
    return JSON.stringify(reduceOrderLine(orderLine))
}

// This function reduces an order line to only the properties relevant;
// for determining stackability: If a data point is represented below,
// inequality on that point will prevent two order lines from being stacked
// If you make changes to this function, please make sure to update the equivalent
// function in the mobile repo!!
function reduceOrderLine(orderLine) {
    return {
        sellableUuid: orderLine.sellable.uuid,
        sellableType: orderLine.sellable_type,
        price: orderLine.price,
        percentage_discount: orderLine.percentage_discount ?? null,
        comment: orderLine.comment ?? null, // I expect we need this here, unless we make a query "stack with order line with same comment"
        receipt_text: orderLine.receipt_text ?? null, // Same for this as comment
        optouts: (orderLine.optouts ?? [])
            .filter((optout) => optout.selected)
            .map((optout) => ({
                uuid: optout.uuid,
                name: optout.name,
            })),
        slaves: (orderLine.slaves ?? []).map((slave) => reduceOrderLine(slave)),
    }
}

export function addPriceToOrderLine(orderLine) {
    return {
        ...orderLine,
        price: orderLine.price ?? orderLine.sellable.price, // Gift card sales already have price, so null coalesce is necessary
        slaves: (orderLine.slaves ?? []).map(addPriceToOrderLine),
    }
}

// Remember to reflect any changes made here to mobile!
// We only check the equality of lengths in order to avoid errors if this function should be
// called improperly. Really, this function assumes that the two order lines have been determined
// to be equal in all stackability-relevant aspects. This is the final check to ensure we do not
// stack order lines that have uneven modifier quantities, as it may make it harder for a server
// to determine the structure of different guests' orders
export function orderLineSlaveQuantitiesAreProportional(orderLine1, orderLine2) {
    const rootQty1 = orderLine1.quantity
    const rootQty2 = orderLine2.quantity
    const getSlaveQuantities = (ol) =>
        (ol.slaves ?? []).flatMap((slave) => [slave.quantity, ...getSlaveQuantities(slave)])

    const slaveQtys1 = getSlaveQuantities(orderLine1)
    const slaveQtys2 = getSlaveQuantities(orderLine2)
    const slaveQtys1Divided = slaveQtys1.map((qty) => qty / rootQty1)
    const slaveQtys2Divided = slaveQtys2.map((qty) => qty / rootQty2)

    return (
        slaveQtys1Divided.length === slaveQtys2Divided.length &&
        slaveQtys1Divided.every((q1, index) => slaveQtys2Divided[index] === q1)
    )
}

export function getStructuredOrderLineQuantities(orderLine) {
    return [orderLine.quantity, (orderLine.slaves ?? []).map(getStructuredOrderLineQuantities)]
}
